module.exports = __webpack_public_path__ + "Roboto-Bold.eb43b4c3b3b6cac224f7.woff";


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/OESS_LFB_V2demo/src/assets/fonts/Roboto-Bold.woff
// module id = ../../../../../src/assets/fonts/Roboto-Bold.woff
// module chunks = main